
export const not_translatable = {
    "plural_template_with_zero_placeholder" : "{num, plural, =0 {{zero}} =1 {# {one}} few {# {few}} other {# {other}}}",
}